import React from 'react';
import StatusBar from './StatusBar';

interface Item {
  id: number;
  label: string;
  state: number;
}

interface CardProps {
  title: string;
  items: Item[];
  onUpdate: (id: number, newState: number) => Promise<void>;
}

const Card: React.FC<CardProps> = ({ title, items, onUpdate }) => {
  return (
    <div className="card">
      <div className="card-header">{title}</div>
      <div className="card-content">
        {items.map((item) => (
          <div key={item.id} className="item-row">
            <div className="item-label">{item.label}</div>
            <StatusBar 
              state={item.state} 
              onStateChange={(newState) => onUpdate(item.id, newState)} 
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Card;
